var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsStarShine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3008 18.7L18.3008 15.7L19.7008 14.3L22.7008 17.3L21.3008 18.7ZM17.7008 6.7L16.3008 5.3L19.3008 2.3L20.7008 3.7L17.7008 6.7ZM6.30078 6.7L3.30078 3.7L4.70078 2.3L7.70078 5.3L6.30078 6.7ZM2.70078 18.7L1.30078 17.3L4.30078 14.3L5.70078 15.7L2.70078 18.7ZM5.82578 21L7.45078 13.975L2.00078 9.25L9.20078 8.625L12.0008 2L14.8008 8.625L22.0008 9.25L16.5508 13.975L18.1758 21L12.0008 17.275L5.82578 21Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsStarShine);
export default __webpack_public_path__ + "static/media/material-symbols_star-shine.87cc8aba0c5064065cce1773f236aa49.svg";
export { ForwardRef as ReactComponent };